import React, { memo, useContext } from "react";
import { makeStyles } from "@mui/styles";
import {
  Box,
  Button,
  Collapse,
  Divider,
  IconButton,
  TableCell,
  TableRow,
} from "@mui/material";

import { useState } from "react";
import ConfirmacionDialog from "../../../../components/Extra/ConfirmacionDialog";
import { withRouter } from "react-router";
import ButtonsAction from "./ButtonsAction";
import AuthContext from "../../../../Context/Auth/AuthContext";
import { Download } from "@mui/icons-material";
import CarnetVacunas from "../../CarnetVacunas/CarnetVacunas";
import CollapseCell from "../../../../components/Extra/CollapseCell";
import CallNombrePersona from "../../../components/Tablas/CallNombrePersona";
const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: ".5px solid #ccc",
    },
  },
  hover: {
    "&:hover": {
      opacity: ".7",
      cursor: "pointer",
    },
  },
  celda: {
    fontSize: ".7rem !important",
  },
  active: {
    borderBottom: "5px solid #ccc",
    backgroundColor: "#354046",
  },
  color: {
    color: "white",
    margin: "0px",
    padding: "2px",
  },
}));

const Row = (props) => {
  const {
    arrayExport,
    setarrayExport,
    row,
    index,
    campoExport,
    puedeExportar,
    desdeOtroLugar,
    seteditar,
    setopen,
    changeObjetoActivoState,
    socket,
    tienePermiso,
    alertaPermiso,
    eliminadoEstado,
  } = props;
  const { usuario } = useContext(AuthContext);
  const classes = useRowStyles();

  const handleEliminar = async (_id) => {
    if (!tienePermiso("eliminar")) {
      return alertaPermiso("eliminar");
    }
    try {
      socket.current.emit("client:eliminarData", {
        nombre: usuario.nombre,
        tabla: "historiaclinica",
        rucempresa: usuario.rucempresa,
        rol: usuario.rol,
        hcliUser: usuario.usuario,
        hcliEmpresa: usuario.rucempresa,
        hcliId: row.hcliId,
      });
    } catch (error) {}
  };
  const funcionEdit = () => {
    setopen(true);
    seteditar(true);
    changeObjetoActivoState({ ...row, restaurado: eliminadoEstado });
  };
  const funcionCopiar = () => {
    changeObjetoActivoState(row);
    setopen(true);
  };
  const [celComprimida, setcelComprimida] = useState({});
  const [openConfirmDialog, setopenConfirmDialog] = useState(false);

  const [seccion, setseccion] = useState({
    vacunasSeccion: true,
  });
  const { vacunasSeccion } = seccion;

  // eslint-disable-next-line
  const [tab, settab] = useState("");
  const [expandir, setexpandir] = useState(false);
  // eslint-disable-next-line
  const [arrayExportHijos, setarrayExportHijos] = useState([]);
  const [desdeOtroLugarMascota] = useState(true);
  return (
    <React.Fragment>
      <ConfirmacionDialog
        open={openConfirmDialog}
        setopen={setopenConfirmDialog}
        titulo={`¿Esta seguro de eliminar este registro?`}
        _id={row._id}
        funcion={handleEliminar}
      />
      <TableRow className={classes.root} selected={index % 2 === 0}>
        {/* boton */}
        <ButtonsAction
          eliminadoEstado={eliminadoEstado}
          arrayExport={arrayExport}
          setarrayExport={setarrayExport}
          row={row}
          setopenConfirmDialog={setopenConfirmDialog}
          funcionEdit={funcionEdit}
          ocultarEditar={false}
          ocultarDelete={false}
          mostrarEstado={false}
          campoExport={campoExport}
          campoEstado=""
          puedeExportar={puedeExportar}
          desdeOtroLugar={desdeOtroLugar}
          expandir={expandir}
          setexpandir={setexpandir}
          funcionCopiar={funcionCopiar}
        />
        <>
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            {row.hcliPerNombre}
          </TableCell>{" "}
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            {row.hcliId}
          </TableCell>
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            {row.hcliMascNombre}
          </TableCell>
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            {row.hcliPerNombreVetInt}
          </TableCell>{" "}
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            {row.hcliPerNombreVetExt}
          </TableCell>
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            {row.hcliFecha}
          </TableCell>
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            {row.hcliMotiConsulMedica}
          </TableCell>
          <CollapseCell
            celComprimida={celComprimida}
            setcelComprimida={setcelComprimida}
            row={row}
            propiedad={"hcliDescripcion"}
          />
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            {row.hcliPeso}
          </TableCell>
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            {row.hcliArchivo === "" ? (
              "No hay documento"
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                padding="none"
                alignItems="center"
              >
                <IconButton
                  size="small"
                  className={classes.margin}
                  onClick={() => {
                    window.open(row.hcliArchivo);
                  }}
                >
                  <Download fontSize="small" color="primary" />
                </IconButton>
              </Box>
            )}
          </TableCell>
          <CallNombrePersona user={row.hcliUser} />
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            {new Date(row.hcliFecUpd).toLocaleString("es-ES", {
              weekday: "short",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour: "2-digit",
            })}
          </TableCell>
        </>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={21}>
          <Collapse in={expandir} timeout="auto" unmountOnExit>
            <Box
              mt={1}
              display="flex"
              justifyContent="space-between"
              alignItems=" stretch"
              width="100%"
            >
              <Box>
                <>
                  <Button
                    size="small"
                    variant={vacunasSeccion ? "contained" : null}
                    onClick={async () => {
                      setseccion({ vacunasSeccion: true });
                      settab("");
                      setarrayExportHijos([]);
                    }}
                    disableElevation
                    style={{
                      padding: ".5rem",
                      borderRadius: "15px 15px  0px 0px",
                    }}
                    color="primary"
                  >
                    Vacunas
                  </Button>
                </>
              </Box>
            </Box>
            <Divider style={{ display: "block", width: "100%" }} />
            <Box p={2}>
              {vacunasSeccion ? (
                <CarnetVacunas
                  idmascota={row.hcliMascId}
                  settab={settab}
                  setarrayExportHijos={setarrayExportHijos}
                  desdeOtroLugarMascota={desdeOtroLugarMascota}
                  puedeExportar={puedeExportar}
                  itemRelacionadoPadre={row}
                />
              ) : null}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default withRouter(memo(Row));
